import apiClient from '../client';

export const imgsApi: any = {
    upload: (payload: File[]) => {
        const formData = new FormData();
        for (const file of payload) {
            formData.append('images', file);
        }
        return apiClient.post(`/product/upload-images`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
};
